<template>
    <v-card class="section-card px-5 py-5" outlined>
        <div class="d-flex align-center">
          <h2>{{ $t('titles.portfolio') }}</h2>
          <v-chip small class="ml-3" @click="educationalVideo('Portfolio')">{{ $t('btnHowToUseIt') }}<v-icon small right>fa-info-circle</v-icon></v-chip>
        </div>
        <PortfolioStats/>

        <v-divider class="my-5"/>

        <div class="d-flex align-center">
          <h2>{{ $t('titles.asset') }}</h2>
          <v-chip small class="ml-3" @click="educationalVideo('Asset')">{{ $t('btnHowToUseIt') }}<v-icon small right>fa-info-circle</v-icon></v-chip>
        </div>
        <AssetStats/>

        <v-divider class="my-5"/>

        <div class="d-flex align-center">
          <h2>{{ $t('titles.side') }}</h2>
          <v-chip small class="ml-3" @click="educationalVideo('Side')">{{ $t('btnHowToUseIt') }}<v-icon small right>fa-info-circle</v-icon></v-chip>
        </div>
        <SideStats/>

        <v-divider class="my-5"/>

        <div class="d-flex align-center">
          <h2>{{ $t('titles.time') }}</h2>
          <v-chip small class="ml-3" @click="educationalVideo('Time')">{{ $t('btnHowToUseIt') }}<v-icon small right>fa-info-circle</v-icon></v-chip>
        </div>
        <TimeStats/>

        <v-divider class="my-5"/>

        <div class="d-flex align-center">
          <h2>{{ $t('titles.mood') }}</h2>
          <v-chip small class="ml-3" @click="educationalVideo('Mood')">{{ $t('btnHowToUseIt') }}<v-icon small right>fa-info-circle</v-icon></v-chip>
        </div>
        <MoodStats/>

        <v-divider class="my-5"/>

        <div class="d-flex align-center">
          <h2>{{ $t('titles.strategy') }}</h2>
          <v-chip small class="ml-3" @click="educationalVideo('Strategy')">{{ $t('btnHowToUseIt') }}<v-icon small right>fa-info-circle</v-icon></v-chip>
        </div>
        <StrategyStats/>

        <div class="d-flex align-center">
          <h2>{{ $t('titles.swisetRatio') }}</h2>
          <v-chip small class="ml-3" @click="educationalVideo('SwisetRatio')">{{ $t('btnHowToUseIt') }}<v-icon small right>fa-info-circle</v-icon></v-chip>
          <v-chip class="ml-2" color="secondary" small><p class="my-0" style="font-size: 14px;">PRO <v-icon class="mt-n1" color="accent" x-small>fa-star</v-icon></p></v-chip>
        </div>
        <SwisetRatioStats @goToPro="seeProAdvantages = true"/>

        <div class="d-flex align-center">
          <h2>{{ $t('titles.riskAndReturn') }}</h2>
          <v-chip class="ml-2" color="secondary" small><p class="my-0" style="font-size: 14px;">PRO <v-icon class="mt-n1" color="accent" x-small>fa-star</v-icon></p></v-chip>
        </div>
        <RiskReturnStats @goToPro="seeProAdvantages = true"/>

        <div class="d-flex align-center">
          <h2>{{ $t('titles.byMarket') }}</h2>
          <v-chip class="ml-2" color="secondary" small><p class="my-0" style="font-size: 14px;">PRO <v-icon class="mt-n1" color="accent" x-small>fa-star</v-icon></p></v-chip>
        </div>
        <ByMarketStats @goToPro="seeProAdvantages = true"/>

        <!-- Overlay for educational video!-->
        <v-overlay v-model="overlayVideo">
            <EducationalVideo :title="title" :video-url="videoUrl" @closeWindow="overlayVideo = false"/>
        </v-overlay>

      <!-- Overlay for Upgrade to Pro!-->
      <v-overlay v-model="seeProAdvantages">
        <UpgradeToPro :message="messageUpgradeToPro" @closeWindow="seeProAdvantages = false"/>
      </v-overlay>

      <!-- Overlay for Loading Trades!-->
      <v-overlay v-model="$store.state.book.loadingTrades">
        <lottie :options="lottieOptions" :height="250" :width="250"/>
      </v-overlay>
    </v-card>
</template>

<script>
    import * as animationData from '@/assets/animations/loading.json';
    import AssetStats from "../AssetStats";
    import PortfolioStats from "../PortfolioStats";
    import TimeStats from "../TimeStats";
    import StrategyStats from "../StrategyStats";
    import SideStats from "../SideStats";
    import MoodStats from "../MoodStats";
    import EducationalVideo from "../../../components/EducationalVideo";
    import SwisetRatioStats from "@/views/Journal/SwisetRatioStats";
    import RiskReturnStats from "@/views/Journal/RiskReturnStats";
    import UpgradeToPro from "@/components/UpgradeToPro";
    import ByMarketStats from "@/views/Journal/ByMarketStats";
    import {mapMutations} from 'vuex';
    export default {
        name: "BookStats",
        components: {
          ByMarketStats,
          UpgradeToPro, RiskReturnStats, SwisetRatioStats, EducationalVideo, MoodStats, SideStats, StrategyStats, TimeStats, PortfolioStats, AssetStats
        },
        props: {
            externalUser: Boolean,
            externalUserId: Number,
        },
        mounted(){
          this.setChartsToDark();
        },
        data() {
            return {
                lottieOptions: { animationData: animationData.default, },
                seeProAdvantages: false,
                messageUpgradeToPro: 'You cannot see pro stats. With Pro you can get all the professional statistics and more.',

                // Educational Video
                overlayVideo: false,
                title: 'Profitability Stats',
                videoUrl: 'n0kW2kozmxw',
            };
        },
        methods: {
            ...mapMutations(['setTradesPageable']),
            backToTrades() {
                this.setTradesPageable({
                size: 15,
                page: 0,
                sort: 'openTime,desc',
              });
                this.$router.push((this.externalUser)? '/book/shared' : '/book');
            },
            educationalVideo(stat) {
                switch (stat) {
                    case 'Portfolio':
                        this.title = this.$t('titles.portfolio');
                        this.videoUrl = 'WFOaSVvkKe4';
                        break;
                    case 'Profitability':
                        this.title = this.$t('titles.profitability');
                        this.videoUrl = 'n0kW2kozmxw';
                        break;
                    case 'Asset':
                        this.title = this.$t('titles.asset');
                        this.videoUrl = 'COcgXbpa2gg';
                        break;
                    case 'Side':
                        this.title = this.$t('titles.side');
                        this.videoUrl = 'COPFcGvoQ84';
                        break;
                    case 'Time':
                        this.title = this.$t('titles.time');
                        this.videoUrl = 'bMzDWVvYfUE';
                        break;
                    case 'Mood':
                        this.title = this.$t('titles.mood');
                        this.videoUrl = 'Zl7rYLwYvaQ';
                        break;
                    case 'SwisetRatio':
                      this.title = this.$t('titles.swisetRatio');
                      this.videoUrl = 'JkzLCKGG_3g';
                      break;
                    default:
                        this.title = this.$t('titles.strategy');
                        this.videoUrl = '08H9np6sZvQ';
                        break;
                }
                this.overlayVideo = true;
            },
            setChartsToDark(){
              document.querySelectorAll(".apexcharts-theme-light").forEach((el)=>{
                //eslint-disable-next-line no-console
                console.log(el)
                el.classList.remove("apexcharts-theme-light");
                el.classList.add("apexcharts-theme-dark");
              })
            }
        }
    }
</script>

<i18n>
{
  "en": {
    "btnBack": "Back",
    "btnHowToUseIt": "Learn how to use it",
    "titles": {
      "portfolio": "Portfolio Stats",
      "profitability": "Profitability Stats",
      "asset": "Asset Stats",
      "side": "Side Stats",
      "time": "Time Stats",
      "mood": "Mood Stats",
      "strategy": "Strategy Stats",
      "swisetRatio": "Swiset Ratio Stats",
      "riskAndReturn": "Risk and Return Stats",
      "byMarket": "By Market Stats"
    }
  },
  "es": {
    "btnBack": "Atrás",
    "btnHowToUseIt": "Aprende cómo usarlo",
    "titles": {
      "portfolio": "Estadísticas de Portafolio",
      "profitability": "Estadísticas de Rentabilidad",
      "asset": "Estadísticas de Activo",
      "side": "Estadísticas de Lado",
      "time": "Estadísticas Temporales",
      "mood": "Estadísticas de Sentimiento",
      "strategy": "Estadísticas de Estrategia",
      "swisetRatio": "Estadísticas de Ratio Swiset",
      "riskAndReturn": "Estadísticas de Riesgo/Retorno",
      "byMarket": "Estadísticas por Mercado"
    }
  }
}
</i18n>

<style scoped>
    .fixed-component {
        background-color: var(--v-light-base);
        position: relative;
        z-index: 1;
    }

    .old-filters{
      display: none;
    }
</style>
